import { Component, Input, Output, EventEmitter, ElementRef, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExpenseSelectionModalComponent } from '../expense-selection-modal/expense-selection-modal';
import { AccountItem } from '../expense-selection-modal/expense-selection-modal';
import { CalendarComponent } from '../../calendar/calendar';

@Component({
    selector: 'app-expense-tracker-modal',
    standalone: true,
    imports: [CommonModule, FormsModule, ExpenseSelectionModalComponent, CalendarComponent],
    templateUrl: './expense-tracker-modal.html',
    styleUrl: './expense-tracker-modal.scss'
})
export class ExpenseTrackerModalComponent {
    @Input() isOpen: boolean = false;
    @Output() close = new EventEmitter<void>();

    @ViewChild(ExpenseSelectionModalComponent, { read: ElementRef }) accountDropdownRef!: ElementRef;
    @ViewChild(CalendarComponent, { read: ElementRef }) calendarRef!: ElementRef;

    selectedAccounts: string = '**** 5645, **** 2345, **** 7567';
    startDate: string = '05 July 2025';
    finalDate: string = '08 July 2025';

    months: string[] = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    isAccountDropdownOpen: boolean = false;
    isCalendarOpen: boolean = false;
    activeDateType: 'start' | 'final' | null = null;

    toggleAccountDropdown(event: Event) {
        event.stopPropagation();
        this.isAccountDropdownOpen = !this.isAccountDropdownOpen;
        this.isCalendarOpen = false;
    }

    toggleCalendar(type: 'start' | 'final', event: Event) {
        event.stopPropagation();
        if (this.activeDateType === type && this.isCalendarOpen) {
            this.isCalendarOpen = false;
            this.activeDateType = null;
        } else {
            this.activeDateType = type;
            this.isCalendarOpen = true;
        }
        this.isAccountDropdownOpen = false;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (this.isAccountDropdownOpen && this.accountDropdownRef && !this.accountDropdownRef.nativeElement.contains(event.target)) {
            this.isAccountDropdownOpen = false;
        }
        if (this.isCalendarOpen && this.calendarRef && !this.calendarRef.nativeElement.contains(event.target)) {
            this.isCalendarOpen = false;
            this.activeDateType = null;
        }
    }

    onDateSelect(date: Date) {
        const formattedDate = this.formatDate(date);
        if (this.activeDateType === 'start') {
            this.startDate = formattedDate;
        } else if (this.activeDateType === 'final') {
            this.finalDate = formattedDate;
        }
        this.isCalendarOpen = false;
        this.activeDateType = null;
    }

    private formatDate(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = this.months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }

    private parseDate(dateStr: string): Date {
        const parts = dateStr.split(' ');
        if (parts.length === 3) {
            const day = parseInt(parts[0]);
            const monthName = parts[1];
            const year = parseInt(parts[2]);
            const monthIndex = this.months.indexOf(monthName);
            if (monthIndex !== -1) {
                return new Date(year, monthIndex, day);
            }
        }
        return new Date(dateStr) || new Date();
    }

    getSelectedDate(): Date {
        if (this.activeDateType === 'start') {
            return this.parseDate(this.startDate);
        } else if (this.activeDateType === 'final') {
            return this.parseDate(this.finalDate);
        }
        return new Date();
    }

    onAccountSelectionChange(selectedItems: any[]) {
        if (selectedItems.length > 0) {
            this.selectedAccounts = selectedItems.map(item => `**** ${item.cardNumber}`).join(', ');
        } else {
            this.selectedAccounts = 'Select Accounts';
        }
        this.isAccountDropdownOpen = false;
    }

    onClose() {
        this.close.emit();
    }

    onOverlayClick(event: MouseEvent) {
        if (event.target === event.currentTarget) {
            this.onClose();
        }
    }

    onSave() {

        this.close.emit();
    }
}
